import * as actionTypes from "./actionTypes";
// import { reviews } from "../../data";
import { firebase, timestamp } from "../../firebase/index";
import { collections, documents } from "../../firebase/firestoreNameSpaces";
import { capitalizeFirstLetter } from "../utility";

export const fetchReviews = (productId, variantId) => {
  return (dispatch, getState) => {
    // let limit = getState().review.limit;
    // let isReviewAvailable = false;
    let reviews = getState().review.reviews;
    if (reviews.length) {
      return "";
    }
    dispatch({
      type: actionTypes.REVIEWS_CONTROLS,
      payload: { loading: true },
    });
    let db = firebase.firestore();
    db.collection(collections.REVIEWS)
      .doc(productId)
      .get()
      .then((snapshot) => {
        let reviewsfetched = [];
        let data = snapshot.data();
        for (let userKey in data) {
          reviewsfetched.push(data[userKey]);
        }
        console.log(reviewsfetched);
        dispatch({
          type: actionTypes.REVIEWS_CONTROLS,
          payload: { reviews: reviewsfetched, loading: false },
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REVIEWS_CONTROLS,
          payload: { reviews: [], loading: false },
        });
        return alert(err);
      });
  };
};
export const loadMoreReview = (serviceName, services) => {
  return (dispatch, getState) => {
    let { leadsexhausted, lastDoc, limit } = getState().review;
    if (leadsexhausted) {
      // return alert("Leads Exhausted");
      return true;
    }
    let service = services.filter(
      (serviceObj) => serviceObj.serviceName == serviceName
    )[0];
    if (service && service.serviceId) {
      let serviceId = service.serviceId;
      dispatch({
        type: actionTypes.REVIEWS_CONTROLS,
        payload: { loading: true },
      });
      let db = firebase.firestore();
      db.collection(collections.REVIEWS)
        .where("serviceId", "==", serviceId)
        .startAfter(lastDoc)
        .limit(limit)
        .get()
        .then((snapshot) => {
          let reviewsfetched = getState().review.reviews;
          lastDoc = snapshot.docs[snapshot.size - 1];
          snapshot.forEach((review) => {
            reviewsfetched.push(review.data());
          });

          if (snapshot.size < limit) {
            dispatch({
              type: actionTypes.REVIEWS_CONTROLS,
              payload: {
                reviews: reviewsfetched,
                loading: false,
                lastDoc: lastDoc,
                leadsexhausted: true,
              },
            });
          } else {
            dispatch({
              type: actionTypes.REVIEWS_CONTROLS,
              payload: {
                reviews: reviewsfetched,
                loading: false,
                lastDoc: lastDoc,
              },
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: actionTypes.REVIEWS_CONTROLS,
            payload: { loading: false },
          });
          return alert(err);
        });
    } else {
      return null;
    }
  };
};
const computeRating = (productId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let rating = 0;
      let rateCount = 0;
      let reviewCount = 0;
      let db = firebase.firestore();
      let results = (
        await db.collection(collections.REVIEWS).doc(productId).get()
      ).data();
      if (results) {
        for (let userKey in results) {
          let reviewObj = results[userKey];
          if (reviewObj.rating) {
            rateCount = rateCount + 1;
            rating = rating + reviewObj.rating;
          }
          if (reviewObj.review) {
            reviewCount = reviewCount + 1;
          }
        }
        resolve({ rating: rating / rateCount, reviewCount });
      } else {
        return resolve(resolve({ rating: 0, reviewCount: 0 }));
      }
    } catch (error) {
      return resolve(false);
    }
  });
};
//need waybill and productId
export const onPostReview = (
  userId,
  order,
  product,
  rating,
  review,
  reviewHeadline
) => {
  return async (dispatch, getState) => {
    // return console.log(product.waybill,order.receipt)

    dispatch({
      type: actionTypes.REVIEWS_CONTROLS,
      payload: { writeReviewLoading: true },
    });

    let address = order.address;
    let productId = product.id;
    let variantId = product.variantId ? product.variantId : "";
    let waybill = product.waybill;
    let receipt = order.receipt;

    let orderreviewdata = {};

    let reviewdata = {
      receipt: receipt,
      userId,
      userName: address.firstname + " " + address.lastname,
      productId,
      variantId,
      city: address.city,
      country: address.country,
    };

    if (rating) {
      reviewdata["rating"] = rating;
      orderreviewdata["rating"] = rating;
    }
    if (review) {
      reviewdata["review"] = review;
      orderreviewdata["review"] = review;
    }
    if (reviewHeadline) {
      reviewdata["reviewHeadline"] = reviewHeadline;
      orderreviewdata["reviewHeadline"] = reviewHeadline;
    }

    let attrs = [];
    if (product.attributes) {
      let attributes = product.attributes;
      for (let attrkey in attributes) {
        attrs.push(
          `${capitalizeFirstLetter(attributes[attrkey].attribute)}: ${
            attributes[attrkey].name
          }`
        );
      }
    }

    reviewdata["attributes"] = attrs;
    reviewdata["timestamp"] = timestamp.now().seconds * 1000;

    // try{
    //   //Shift this computeRating to cloud functions
    //   let result =  await computeRating(productId);
    //   if(result){
    //       let {rating, reviewCount } = result;
    //       let pref = db.collection(collections.PRODUCTS).doc(productId);
    //       batch.set(pref, {rating:rating,reviewCount:reviewCount},{merge:true})
    //   }

    // }catch(error){

    // }
    //  let orderRef =  db.collection(collections.ORDERS).doc(order.receipt);
    //  let productRef = db.collection(collections.REVIEWS).doc(productId);

    //  batch.set(orderRef,{packageStatus:{[waybill]:{ ...orderreviewdata } }} , {merge:true} );
    //  batch.set(productRef,{[userId]: reviewdata },{merge:true})

    let body = {
      userId,
      productId,
      waybill,
      receipt,
      orderreviewdata,
      reviewdata,
    };
    var postReview = firebase.functions().httpsCallable("postReview");
    postReview(body)
      .then(() => {
        let ongoingOrders = getState().bookings.ongoingOrders;
        let neworder = ongoingOrders.filter(
          (orderObj) => orderObj.receipt == order.receipt
        )[0];
        let modalid = product.variantId ? product.variantId : product.id;

        if (neworder) {
          if (rating) {
            neworder.rating = rating;
          }
          if (review) {
            neworder.review = review;
          }
          dispatch({
            type: actionTypes.REVIEWS_CONTROLS,
            payload: { writeReviewLoading: false },
          });
          // dispatch({
          //   type:actionTypes.BOOKINGS_CONTROLS,
          //   payload:{ongoingOrders:ongoingOrders}
          // })
          // document.getElementById(`review${order.receipt}`).click()
          document.getElementById(`reviews${modalid}`).children[0].click();
          // window.location.reload();
        } else {
          // window.location.reload();
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.REVIEWS_CONTROLS,
          payload: { writeReviewLoading: false },
        });

        return alert(err);
      });
  };
};
